import { languages } from './constants';

export const getCurrentLang = (): string => {
  const supportedLanguages = languages.map((lang) => lang.code);
  const pathLang = window.location.pathname.split('/')[1];

  return supportedLanguages.includes(pathLang) ? pathLang : 'en';
};
